import { LeihBarPermissions } from '@thro-types/access-handler';

import { Route, Routes, useLocation } from 'react-router';

import { useSelfEntitlementGroupsQuery } from 'api/hooks/users';
import PrivateRoute from 'app/components/Util/PrivateRoute';

import { canUserEdit } from '../helper';
import CreateArticlePage from './CreateArticlePage';

export const Articles = ({ currentUser, userPermission }) => {
  const location = useLocation();
  const { data: myEntitlementGroups } = useSelfEntitlementGroupsQuery();

  return (
    <Routes>
      <Route
        path="create"
        element={
          <PrivateRoute
            user={currentUser}
            userPermissions={userPermission}
            requiredPermission={LeihBarPermissions.LEIHBAR_PRODUCT_CREATE}
          >
            <CreateArticlePage />
          </PrivateRoute>
        }
      />
      <Route
        path="edit/:id"
        element={
          <PrivateRoute
            user={currentUser}
            userPermissions={userPermission}
            requiredPermission={LeihBarPermissions.LEIHBAR_PRODUCT_EDIT_ANY}
            canAccess={
              location.state?.article?.product &&
              canUserEdit(
                location.state?.article?.product,
                userPermission,
                currentUser,
                myEntitlementGroups
              )
            }
          >
            <CreateArticlePage />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
